/**
 * 画面単位のロールガード。権限が無いときはロール別の初期画面へ戻す。
 * ルールでも同じ制限をかけている(firestore.rules)ため、これはUX目的の二重化。
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@core/auth/AuthProvider';

export default function RequireRole({ allowed, children }: { allowed: boolean; children: ReactNode }) {
  const { homePath } = useAuth();
  if (!allowed) return <Navigate to={homePath} replace />;
  return <>{children}</>;
}
